import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import FeatureLockedModal from "./FeatureLockedModal";
import { useEntitlements } from "../useEntitlements";

export default function MessagingRouteGate({ children }) {
  const { entitlements, isOrgOwner, isLoading } = useEntitlements();
  const [modalOpen, setModalOpen] = useState(true);

  if (isLoading) return null;
  if (entitlements?.messagingEnabled) {
    return children;
  }

  return (
    <>
      <FeatureLockedModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        featureKey="messaging"
        isOrgOwner={isOrgOwner}
      />
      {!modalOpen ? <Navigate to="/dashboard" replace /> : null}
    </>
  );
}
